import React from 'react';
import './PageNotFound.scss';
import { Link } from 'react-router-dom';

export default function PageNotFound() {
    return (
        <div className='pageNotFound-container '>
            <div className='container grid md:grid-cols-2 grid-cols-1 justify-items-center items-center gap-5 p-5 mx-auto my-auto h-full'>
                <div className='grid grid-cols-1 gap-6'>
                    <img src='/assets/logo/logo.png' className='object-contain h-8' alt='logo' />
                    <div>
                        <p className='font-bold text-[#2F2B3D] sm:text-5xl text-xl'>Oops! Something went wrong</p>
                        <p className='mt-2 text-base'>We can’t seem to find a page you are looking for</p>
                    </div>
                    <Link to={'/dashboard'} className=' text-center text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover sm:w-1/2'>Go To Dashboard
                    </Link>
                </div>
                <div>
                    <img src="/assets/images/pageNotfound.png" alt="" className='w-[35rem] p-4' />
                </div>
            </div>
        </div>
    )
}